module.exports = __webpack_public_path__ + "static/media/aliceblue-slider.f8dfcc16.svg";